import React from "react";

const Checkbox = ({ name, value, onClick, error, text }) => {
  return (
    <div className="checkbox-wrapper">
      <label htmlFor={name} className={value ? "active" : ""}>
        <input
          id={name}
          name={name}
          type="checkbox"
          className={error && "error"}
          value={value}
          onChange={onClick}
        />
        {text}
      </label>
    </div>
  );
};

export default Checkbox;
